import { useContext } from "react";
import { AuthContext } from "../../useAuth";
import { Menu, Row, Col } from "antd";
import { Routes, Route, useNavigate } from "react-router-dom";

/* Pages */
import UserProfile from "./UserProfile";
import UserNotifications from "./UserNotifications";
import CaregiverSettings from "./CaregiverSettings";
import ContentLayout from "../../layout/ContentLayout";
import Loading from "../../components/Loading";

const Profile = () => {
  const { user } = useContext(AuthContext);
  const isCaregiver = user?.Roles?.some((c) => c === "caregiver");

  const items = [
    { label: "Settings", key: "/profile" },
    { label: "Notifications", key: "notifications" },
    {
      label: "Billing",
      key: "/billing",
      children: [
        { label: "Charges", key: "charges" },
        { label: "Invoices", key: "invoices" },
      ],
    },
  ];

  if (isCaregiver) {
    items.push({
      label: "Caregiver Settings",
      key: "caregiver",
    });
  }

  const navigate = useNavigate();

  const menuClick = (item) => {
    const { key } = item;
    navigate(key);
  };
  return !user ? (
    <Loading />
  ) : (
    <>
      <div className="sub-menu">
        <Menu items={items} onClick={menuClick} mode="horizontal" />
      </div>
      <ContentLayout>
        <Routes>
          <Route index element={<UserProfile user={user} />} />
          <Route
            path="/notifications"
            element={<UserNotifications user={user} />}
          />
          <Route
            path="/caregiver"
            element={<CaregiverSettings user={user} />}
          />
        </Routes>
      </ContentLayout>
    </>
  );
};

export default Profile;
